
export const SET_COUNT_UNASSIGNED = 'SET_COUNT_UNASSIGNED';
export const INCREMENT_WORKFLOW_UNASSIGNED='INCREMENT_WORKFLOW_UNASSIGNED';
export const DECREMENT_WORKFLOW_UNASSIGNED='DECREMENT_WORKFLOW_UNASSIGNED';

  const flagUnassignedReducer = (state =[], action) => {
    switch (action.type) {
  
      
        case SET_COUNT_UNASSIGNED:
          return{
            ...state,
            data:action.payload.data
          };
          case INCREMENT_WORKFLOW_UNASSIGNED:
            return{
              ...state,
              data:state.data+1
            };
            case DECREMENT_WORKFLOW_UNASSIGNED:
              return{
                ...state,
                data:state.data-1
              };
  
      default:
        return state;
  
    }
  }
  
  export default flagUnassignedReducer;